import { SelectData } from './select-input.model';

export interface FundClosingFilter {
  dataFundo: Date;
  fechamentoAutomatico: SelectData[];
  status: SelectData[];
  ultimoFechamento: SelectData[];
  rejeicaoArquivoCobranca: SelectData[];
}
